import { compile } from 'path-to-regexp';

export const CASINO_ARTICLE_PATH = '/casino/clanky/:articleCode/:ignoreCache?';

export const CASINO_GAME_DESCRIPTION_PATH = '/casino/game-description/:gameId';

export const CASINO_GAME_PLAY_PATH = '/casino/game/:gameId/:mode';

export const CASINO_KASINO_CATEGORY_PATH = '/casino/kategoria/:categorySlug?';

export const CASINO_CATEGORY_DETAIL_PART_PATH = '/kategoria-detail/:categorySlug?';

export const CASINO_CATEGORY_PATH = '/casino' + CASINO_CATEGORY_DETAIL_PART_PATH;

export const CASINO_HRY_CATEGORY_PATH = '/casino/hry/kategoria/:categorySlug?';

export const CASINO_HISTORY_PATH = '/casino/historia-spinov';
export const SCRATCHCARDS_HISTORY_PATH = '/casino/historia-izrebov';

export const CASINO_HRY_LOBBY_PATH = '/casino/hry';

export const CASINO_KASINO_LOBBY_PATH = '/casino';

export const getCasinoGamePlayUrl = ({ gameId, mode }: { gameId: string; mode: 'fun' | 'money' }) => {
    return decodeURIComponent(compile(CASINO_GAME_PLAY_PATH)({ gameId, mode }));
};

export const getCasinoGameDescriptionURL = ({ gameId }: { gameId: string }) => {
    return decodeURIComponent(compile(CASINO_GAME_DESCRIPTION_PATH)({ gameId }));
};
